import * as React from "react";

function CollapseMenuIcon(props) {
	return (
		<svg viewBox="0 0 20 20" fill="currentColor" height="1em" width="1em" {...props}>
			<path d="M3 3h2v14H3z" />
			<path d="M12.707 6.293L9 10l3.707 3.707 1.414-1.414L11.828 10l2.293-2.293z" />
		</svg>
	);
}

export default CollapseMenuIcon;
